<template>
  <div class="base-container">
    <v-row
      :style="$vuetify.breakpoint.mdAndUp ? { backgroundColor: '#F7F7F7' } : {}"
      :class="$vuetify.breakpoint.smAndDown ? 'pt-3' : 'pt-10'"
      align="center"
      justify="space-between"
      no-gutters
    >
      <v-col cols="12" md="4" class="d-flex align-center justify-center">
        <h3 class="secondary-font text--secondary py-5">Mapeamentos Psicossociais</h3>
      </v-col>
      <v-col cols="12" md="4" class="pb-0 d-flex align-center justify-center">
        <v-tabs v-if="$vuetify.breakpoint.smAndDown" v-model="tab" grow>
          <v-tab href="#tab-abertos">Abertos</v-tab>
          <v-tab href="#tab-finalizados">Finalizados</v-tab>
        </v-tabs>
        <v-btn-toggle v-else v-model="tab" color="primary" rounded>
          <v-btn value="tab-abertos">Abertos</v-btn>
          <v-btn value="tab-finalizados">Finalizados</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-row no-gutters class="h-90">
      <v-col cols="12">
        <v-tabs-items v-model="tab" class="fill-height pt-10 bg-default">
          <v-tab-item value="tab-abertos">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div v-if="carregando" class="text-center mt-6">
                    <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                  </div>
                  <v-data-iterator v-else :items="mapeamentosAbertos" hide-default-footer>
                    <template #default="{ items }">
                      <v-row>
                        <v-col v-for="mapeamento in items" :key="mapeamento.idMapeamento" cols="12" sm="6" lg="4">
                          <MapeamentoCard
                            :mapeamento="mapeamento"
                            @preencher="irParaMapeamento(mapeamento)"
                            @ver-respostas="verRespostas(mapeamento)"
                          />
                        </v-col>
                      </v-row>
                    </template>
                    <template #no-data>
                      <h3 class="text-center secondary-font">Não há mapeamentos abertos no momento.</h3>
                    </template>
                  </v-data-iterator>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item value="tab-finalizados">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div v-if="carregando" class="text-center mt-6">
                    <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                  </div>
                  <v-data-iterator v-else :items="mapeamentosFinalizados" hide-default-footer>
                    <template #default="{ items }">
                      <v-row>
                        <v-col v-for="mapeamento in items" :key="mapeamento.idMapeamento" cols="12" sm="6" lg="4">
                          <MapeamentoCard
                            :mapeamento="mapeamento"
                            finalizado
                            @ver-respostas="verRespostas(mapeamento)"
                          />
                        </v-col>
                      </v-row>
                    </template>
                    <template #no-data>
                      <h3 class="text-center secondary-font">Não há mapeamentos finalizados no momento.</h3>
                    </template>
                  </v-data-iterator>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MapeamentoCard from '@/modules/AvaliacaoPsicossocial/MapeamentoCard.vue'

export default {
  name: 'MapeamentosPsicossociais',
  components: { MapeamentoCard },
  data: () => ({
    tab: 'tab-abertos',
    carregando: true
  }),
  computed: {
    ...mapState('avaliacaoPsicossocial', ['mapeamentosEmpresa']),
    mapeamentosAbertos() {
      const hoje = new Date()
      hoje.setHours(0, 0, 0, 0)
      return (this.mapeamentosEmpresa || []).filter(mapeamento => {
        if (mapeamento.status !== 'ativo') return false
        if (!mapeamento.dtFinal) return true
        const dtFinal = new Date(mapeamento.dtFinal)
        dtFinal.setHours(23, 59, 59, 999)
        return dtFinal >= hoje
      })
    },
    mapeamentosFinalizados() {
      const hoje = new Date()
      hoje.setHours(0, 0, 0, 0)
      return (this.mapeamentosEmpresa || []).filter(mapeamento => {
        if (!mapeamento.dtFinal) return false
        const dtFinal = new Date(mapeamento.dtFinal)
        dtFinal.setHours(23, 59, 59, 999)
        return dtFinal < hoje
      })
    }
  },
  methods: {
    ...mapActions('avaliacaoPsicossocial', ['fetchMapeamentosEmpresa']),
    irParaMapeamento(mapeamento) {
      const urlParams = new URLSearchParams(mapeamento.urlAvaliacao)
      const token = urlParams.get('token')

      if (token) {
        this.$router.push({
          path: '/avaliacao-psicossocial',
          query: { token }
        })
      } else {
        this.$router.push({
          path: '/avaliacao-psicossocial',
          query: {
            encryptedIdMapeamento: urlParams.get('encryptedIdMapeamento'),
            encryptedIdsEmpresas: urlParams.get('encryptedIdsEmpresas')
          }
        })
      }
    },
    verRespostas(mapeamento) {
      this.$router.push(`/psicossocial/respostas/${mapeamento.idMapeamento}`)
    }
  },
  async mounted() {
    this.carregando = true
    try {
      await this.fetchMapeamentosEmpresa()
    } finally {
      this.carregando = false
    }
  }
}
</script>
